import styled from 'styled-components'
import React from 'react'

import S from './styles/Greeting.styles'

const Title = styled('div')`
  text-align: center;
  font-size: 2rem;
  margin-top: 50px;

  @media (min-width: 1024px) {
    text-align: left;
  }
`

const BrandTitle = styled('div')`
  font-size: 1.125rem;
  font-weight: bold;
`

const BrandSubtitle = styled('div')`
  font-size: 1.125rem;
  font-weight: normal;
  margin-top: 30px;
`

const Footer = styled('div')`
  color: inherit;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-bottom: 38px;
  text-decoration: none;
  & > * {
    color: inherit;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-bottom: 38px;
    text-decoration: none;
  }
`

interface IProps {
  customHeader?: React.ReactNode
  children?: React.ReactNode
  customFooter?: React.ReactNode
}

export default function Greeting({children, customHeader, customFooter, ...props}: IProps) {
  const defaultHeader = () => <S.Title>Welcome</S.Title>

  const defaultBody = () => (
    <div>
      <S.Logo icon="brand-logo" />
      <BrandTitle>JobSource</BrandTitle>
      <BrandSubtitle>
        Connect With the World
        <br /> Around You
      </BrandSubtitle>
    </div>
  )

  const defaultFooter = () => <div />

  return (
    <S.Container {...props} sx={{boxShadow: 6}} data-testid="greeting">
      <Title>{customHeader}</Title>
      {children ?? defaultBody()}
      <Footer>{customFooter}</Footer>
    </S.Container>
  )
}
